import type { User } from '@entities/user';
import type { BaseUsecase } from '@usecases/base-usecase';
import {
  InvalidUserLoginRequest,
  isAxiosLikeError,
  MissingIntegrationOrNumberNotAssign,
  type UserLoginEventPublisher,
  type UserLoginRepository,
} from '@usecases/user-login.usecase';

export interface UserUnifiedLoginRequest {
  token: string;
  refreshToken: string;
}

export interface UserUnifiedLoginAuthenticator {
  authenticate(credentials: UserUnifiedLoginRequest): Promise<User>;
}

export type UserUnifiedLoginUsecase = BaseUsecase<
  UserUnifiedLoginRequest,
  void
>;

export class UserUnifiedLogin implements UserUnifiedLoginUsecase {
  constructor(
    private authenticator: UserUnifiedLoginAuthenticator,
    private repository: UserLoginRepository,
    private publisher: UserLoginEventPublisher,
  ) {}

  async run(req: UserUnifiedLoginRequest): Promise<void> {
    try {
      const user = await this.authenticator.authenticate(req);
      console.log('User authenticated successfully', JSON.stringify(user));

      await Promise.all([
        this.repository.addUserDetails(user),
        this.publisher.publish(user),
      ]);
    } catch (error) {
      console.log(
        'Error inside UserLoginEventPublisher details ',
        JSON.stringify(error),
      );
      if (isAxiosLikeError(error)) {
        const status = error.response?.status ?? error.status;

        if (status === 500) {
          throw new MissingIntegrationOrNumberNotAssign(
            'No active integration found or phone number not linked to one.',
            error,
          );
        }

        //could handle other status codes here (e.g., 401, 403, etc.)
      }
      throw new InvalidUserLoginRequest(
        'Unable to login, please try again!',
        error,
      );
    }
  }
}
